




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface CatalogCompensation {
    catalogStrategy: string;
}

@Component({ components: { SimpleText } })
export default class CompensationProgram extends Vue {
    @Prop( { default: null }) public catalogCompensation!: CatalogCompensation;

    public static getNeededFields(): string[] {
        return [
            "catalog.catalogStrategy"
        ];
    }
}
